import React /* , { useEffect, useState } */ from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isSessionExpired, logoutUser } from '../Services/authService';

const PrivateRoute = () => {
  const isAuthenticated = !!localStorage.getItem('accessToken');

  if (isAuthenticated && isSessionExpired()) {
    logoutUser();
    return <Navigate to={`${process.env.PUBLIC_URL || ''}/login`} replace />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL || ''}/login`} replace />;
};

export default PrivateRoute;
